import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function FinListBalaDiyaList({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  const dispatch = useDispatch();
  const [listChecked, setItemList] = useState([]);
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});

  console.log("list to be printed in the console",list)

  var appliedTilteList = [
    "SR.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "Employee COUNT",
    "SPONSOR ID 700",
    "status",
  ];
  const [newCurrentList, setNewCurrentList] = useState([]);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);

  const apiCall = () => {
    updateData("123");
    setCheckedItems({});
    setItemList([]);
  };

  const baladiyaApi = async (type) => {
    try {
      const res = await nodeinstance.post("/baladiya/updatestatus/", type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setCheckedItems({});
        apiCall();
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.error,
        })
      );
    }
  };

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    setItemList((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };
  const [indexValue, setIndex] = useState(10);
  return (
    <>
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 min-w-[1000px]">
            <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
              {appliedTilteList.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>

            {!list?.listData
              ? list?.data?.listData.map((listData, index) => (
                <a
                  key={index}
                  onClick={() => {
                    const filteredData = list?.data?.data.filter(
                      (indexData) =>
                        indexData.visa_provider === listData.visa_provider &&
                        indexData.client_name === listData.client_name &&
                        indexData.baladiya_status === listData.baladiya_status
                    );
                    setNewCurrentList(filteredData);
                    setIndex(index);
                  }}
                  className={`grid grid-cols-table-ajeer-applied gap-5 p-4   text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} `}
                  style={{ cursor: "pointer" }} // Apply pointer cursor style
                >
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.visa_provider || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.client_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={
                          listData.employee_count.toString() || "-"
                        }
                      />
                    </p>
                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.sponsor_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.baladiya_status || "-"}
                      />
                    </p>
                  </React.Fragment>
                </a>
              ))
              : ""}
          </div>
        </div>
      </div>
      {currentList.length !== 0 ? (
        <>
          <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
            <Search
              searchKey={[
                "employee_id",
                "name",
                "actual_profession",
                "visa_professions",
                "visa_provider",
                "iqama_number",
                "client_name"
              ]}
              setSearchWords={setSearchWords}
            />

            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() =>
                baladiyaApi({
                  employee_id: listChecked.map((e) => e.employee_id),
                  baladiya_status: "4",
                })
              }
            >
              <p>Update</p>
            </button>
          </div>
          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
          <CountPerPage />
          <div className="relative bg-white">
            <div className="overflow-x-auto max-h-[70vh] ">
              <div className="sticky top-0 z-10 bg-white min-w-[2700px]">
                <div className="grid grid-cols-table-baladiya-update gap-5 p-6 text-center">
                  {titles.map((t, index) => (
                    <p key={index} className="font-semibold uppercase">
                      {t}
                    </p>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-table-baladiya-update gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.actual_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_professions || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_location || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.fees || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_apply_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_issue_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_expiry_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_valid_days || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={
                            list.baladiya_status_value === null
                              ? ""
                              : list.baladiya_status_value.toString() === "2"
                                ? "Details Pending"
                                : list.baladiya_status || "-"
                          }
                        />
                      </p>
                      <div className="flex items-center mb-0  ">
                        <input
                          disabled={
                            list.baladiya_status_value === null
                              ? ""
                              : list.baladiya_status_value.toString() === "3" ||
                                list.baladiya_status_value === null
                                ? ""
                                : list.baladiya_status_value.toString() === "4"
                                  ? true
                                  : false
                          }
                          key={list.employee_id} // Use a unique identifier as the key
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id, list)
                          }
                        />
                      </div>

                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>
          <Pagination />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
